module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/FullBleedContent-bb1268bea5cfd91c18ef2106aece4534.png";